// Header totals for the Orders report / Location Summary panels in
// CUMULATIVE view. Input: a panel already transformed by
// _ordersCumulativePanels (rows are running totals from prior_state;
// `partial` = still-partial, `unfulfilled` = backlog at end of that day).
//
// 2026-09-02: replaces the old "last row − first row" delta. That was right
// for flow metrics but wrong for the backlog (a stock): it reported net
// GROWTH in unfulfilled (e.g. 8,261) while the table's latest row showed
// the actual backlog (8,787) — the difference being ~500 late-December
// orders that were open on Jan 1 and shipped in January. It also dropped
// the first day's own activity because that row was the baseline.
//
//   unfulfilled       = backlog on the END date (== latest table row)
//   orders/fulfilled/
//   cancelled         = end-date running total − prior_state (whole window,
//                       first day included)
//   partial           = ever-partial events in window
//                       (still-partial + completed-partial at end) − prior ever-partial
//   completed_partial = completed-partial events in window
export function ordersCumulativeTotals(panel) {
    const zero = { orders: 0, fulfilled: 0, cancelled: 0, partial: 0,
                   completed_partial: 0, unfulfilled: 0, modified: 0 };
    const rows = (panel?.rows || []).slice().sort((a, b) =>
        String(a.date).localeCompare(String(b.date)));
    if (!rows.length) return zero;
    const ps   = panel.prior_state || {};
    const last = rows[rows.length - 1];
    const n    = (v) => Number(v) || 0;
    const everPartialEnd   = n(last.partial) + n(last.completed_partial);
    const everPartialPrior = n(ps.partial);
    return {
        orders:            n(last.orders)    - n(ps.orders),
        fulfilled:         n(last.fulfilled) - n(ps.fulfilled),
        cancelled:         n(last.cancelled) - n(ps.cancelled),
        partial:           Math.max(0, everPartialEnd - everPartialPrior),
        completed_partial: n(last.completed_partial) - n(ps.completed_partial),
        unfulfilled:       n(last.unfulfilled),
        modified:          0, // not displayed in cumulative
    };
}
